import React, { useEffect } from 'react';
import {Navigate} from "react-router-dom";
import {useSelector} from "react-redux";
export { Home };


function Home() {

    const accessTo = useSelector(x => x.auth.accessTo);

    return (
        (accessTo &&
            (accessTo.PROSPECT_ONLY) ? (<Navigate to="/user_projects"/>) : (<Navigate to="/dashboard"/>)
        )
    );
}
